

























































































































































































































































































import Vue from 'vue';

import CustomDialog from '../../components/CustomDialog.vue';
import ThePacientesCadastroInternoDadosPessoais from '../../components/pacientes/ThePacientesCadastroInternoDadosPessoais.vue';
import ThePacientesTabela from '../../components/pacientes/ThePacientesTabela.vue';

export default Vue.extend({
  name: 'PacientesIndex',
  components: {
    CustomDialog,
    ThePacientesCadastroInternoDadosPessoais,
    ThePacientesTabela,
  },
  data() {
    return {
      dialogNovaPaciente: false,
      tab: 0,
      search: '',
      lastSearch: '',
      loading: {
        triagem: true,
        coletivo: true,
        casaDeParto: true,
        particular: true,
        canceladas: true,
      },
      totalRegistros: {
        triagem: 0,
        coletivo: 0,
        casaDeParto: 0,
        particular: 0,
        canceladas: 0,
      },
    };
  },
  computed: {
    colorTriagem() {
      if (this.tab !== 0) {
        if (this.loading.triagem) {
          return 'grey';
        }
        if (this.lastSearch && this.totalRegistros.triagem > 0) {
          return 'error';
        }
        return 'grey';
      }
      return 'primary';
    },
    colorColetivo() {
      if (this.tab !== 1) {
        if (this.loading.coletivo) {
          return 'grey';
        }
        if (this.lastSearch && this.totalRegistros.coletivo > 0) {
          return 'error';
        }
        return 'grey';
      }
      return 'primary';
    },
    colorCasaDeParto() {
      if (this.tab !== 2) {
        if (this.loading.casaDeParto) {
          return 'grey';
        }
        if (this.lastSearch && this.totalRegistros.casaDeParto > 0) {
          return 'error';
        }
        return 'grey';
      }
      return 'primary';
    },
    colorParticular() {
      if (this.tab !== 3) {
        if (this.loading.particular) {
          return 'grey';
        }
        if (this.lastSearch && this.totalRegistros.particular > 0) {
          return 'error';
        }
        return 'grey';
      }
      return 'primary';
    },
    colorCanceladas() {
      if (this.tab !== 4) {
        if (this.loading.canceladas) {
          return 'grey';
        }
        if (this.lastSearch && this.totalRegistros.canceladas > 0) {
          return 'error';
        }
        return 'grey';
      }
      return 'primary';
    },
    thePacientesTabelaTriagem(): Vue & { carregaNovaPagina: () => void } {
      return this.$refs.thePacientesTabelaTriagem as Vue & {
        novaPaciente: () => void,
        carregaNovaPagina: () => void,
      };
    },
    thePacientesTabelaColetivo(): Vue & { carregaNovaPagina: () => void } {
      return this.$refs.thePacientesTabelaColetivo as Vue & {
        carregaNovaPagina: () => void,
      };
    },
    thePacientesTabelaCasaDeParto(): Vue & { carregaNovaPagina: () => void } {
      return this.$refs.thePacientesTabelaCasaDeParto as Vue & {
        carregaNovaPagina: () => void,
      };
    },
    thePacientesTabelaParticular(): Vue & { carregaNovaPagina: () => void } {
      return this.$refs.thePacientesTabelaParticular as Vue & {
        carregaNovaPagina: () => void,
      };
    },
    thePacientesTabelaCanceladas(): Vue & { carregaNovaPagina: () => void } {
      return this.$refs.thePacientesTabelaCanceladas as Vue & {
        carregaNovaPagina: () => void,
      };
    },
  },
  methods: {
    novaPaciente(paciente) {
      this.thePacientesTabelaTriagem.novaPaciente(paciente);
      this.dialogNovaPaciente = false;
    },
    limpaBusca() {
      this.search = '';
      this.carregaNovaPagina();
    },
    carregaNovaPagina() {
      this.lastSearch = this.search;
      this.thePacientesTabelaTriagem.carregaNovaPagina(this.search);
      this.thePacientesTabelaColetivo.carregaNovaPagina(this.search);
      this.thePacientesTabelaCasaDeParto.carregaNovaPagina(this.search);
      this.thePacientesTabelaParticular.carregaNovaPagina(this.search);
      this.thePacientesTabelaCanceladas.carregaNovaPagina(this.search);
    },
  },
});
